/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonitoringStatus } from './MonitoringStatus';
import {
    MonitoringStatusFromJSON,
    MonitoringStatusFromJSONTyped,
    MonitoringStatusToJSON,
    MonitoringStatusToJSONTyped,
} from './MonitoringStatus';

/**
 * 
 * @export
 * @interface VehicleRental
 */
export interface VehicleRental {
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    gondolaBookingId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    providerBookingId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    vendorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    pickupLocationCode?: string;
    /**
     * Travelport classification of the booked pickup desk ("Airport", "CityCenterDowntown", "City", ...). Absent means unknown, which clients treat as an airport pickup. Anything else means pickup_location_code is only the metro the desk sits in, so render the address instead of a "<code> Airport" label.
     * @type {string}
     * @memberof VehicleRental
     */
    pickupLocationType?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleRental
     */
    pickupDatetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    dropoffLocationCode?: string;
    /**
     * Travelport classification of the booked dropoff desk. Same semantics as pickup_location_type.
     * @type {string}
     * @memberof VehicleRental
     */
    dropoffLocationType?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleRental
     */
    dropoffDatetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    acrissCode?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    vehicleClass?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    vehicleCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    vehicleDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    transmissionType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleRental
     */
    airConditioning?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleRental
     */
    passengerCount?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleRental
     */
    bagCount?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleRental
     */
    totalRate?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleRental
     */
    dailyRate?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    billingCurrency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleRental
     */
    cancelled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof VehicleRental
     */
    cancelledAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    bookingAgent?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleRental
     */
    bookingDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    loyaltyProgram?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    loyaltyId?: string;
    /**
     * Rental confirmation number. Identity/dedup key for manually-added and email-parsed rentals.
     * @type {string}
     * @memberof VehicleRental
     */
    confirmationNumber?: string;
    /**
     * Rental counter location (e.g., "Terminal 1, Level 1")
     * @type {string}
     * @memberof VehicleRental
     */
    pickupCounterLocation?: string;
    /**
     * Shuttle service details (e.g., "Complimentary shuttle every 10 minutes")
     * @type {string}
     * @memberof VehicleRental
     */
    pickupShuttleInfo?: string;
    /**
     * Street address of the rental facility
     * @type {string}
     * @memberof VehicleRental
     */
    pickupAddress?: string;
    /**
     * Phone number for the rental location
     * @type {string}
     * @memberof VehicleRental
     */
    pickupPhone?: string;
    /**
     * Counter location at the dropoff facility (e.g., "Terminal 1, Level 1")
     * @type {string}
     * @memberof VehicleRental
     */
    dropoffCounterLocation?: string;
    /**
     * Shuttle service details for the dropoff location
     * @type {string}
     * @memberof VehicleRental
     */
    dropoffShuttleInfo?: string;
    /**
     * Street address of the dropoff facility
     * @type {string}
     * @memberof VehicleRental
     */
    dropoffAddress?: string;
    /**
     * Phone number for the dropoff location
     * @type {string}
     * @memberof VehicleRental
     */
    dropoffPhone?: string;
    /**
     * Cancellation policy text from the rental car vendor, captured at booking time.
     * @type {string}
     * @memberof VehicleRental
     */
    cancellationPolicy?: string;
    /**
     * Whether this vehicle rental is opted in to auto-save (rate monitoring and rebooking).
     * @type {boolean}
     * @memberof VehicleRental
     */
    autoSave?: boolean;
    /**
     * Latest rate found by auto-save monitoring.
     * @type {number}
     * @memberof VehicleRental
     */
    currentRate?: number;
    /**
     * Currency code for current_rate.
     * @type {string}
     * @memberof VehicleRental
     */
    currentRateCurrency?: string;
    /**
     * When the current rate was last checked.
     * @type {Date}
     * @memberof VehicleRental
     */
    currentRateUpdatedAt?: Date;
    /**
     * How closely the current rate matches the original booking.
     * @type {string}
     * @memberof VehicleRental
     */
    currentRateMatch?: VehicleRentalCurrentRateMatchEnum;
    /**
     * Vendor code of the matched rate.
     * @type {string}
     * @memberof VehicleRental
     */
    currentRateVendorCode?: string;
    /**
     * ACRISS code of the matched rate.
     * @type {string}
     * @memberof VehicleRental
     */
    currentRateAcrissCode?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRental
     */
    tripId?: string;
    /**
     * URL of the vehicle image from the supplier.
     * @type {string}
     * @memberof VehicleRental
     */
    imageUrl?: string;
    /**
     * 
     * @type {MonitoringStatus}
     * @memberof VehicleRental
     */
    monitoringStatus?: MonitoringStatus;
    /**
     * Human-readable explanation of the monitoring state.
     * @type {string}
     * @memberof VehicleRental
     */
    monitoringReason?: string | null;
    /**
     * Fields the user can provide to enable monitoring or AutoSave.
     * @type {Array<string>}
     * @memberof VehicleRental
     */
    missingFields?: Array<string>;
    /**
     * Whether AutoSave can be enabled for this reservation.
     * @type {boolean}
     * @memberof VehicleRental
     */
    autosaveAvailable?: boolean;
    /**
     * When we last checked the current rate for this reservation.
     * @type {Date}
     * @memberof VehicleRental
     */
    monitoringLastCheckedAt?: Date | null;
}


/**
 * @export
 */
export const VehicleRentalCurrentRateMatchEnum = {
    Exact: 'EXACT',
    Closest: 'CLOSEST',
    Lowest: 'LOWEST',
    Unavailable: 'UNAVAILABLE',
    UnavailableAfterRateSearch: 'UNAVAILABLE_AFTER_RATE_SEARCH'
} as const;
export type VehicleRentalCurrentRateMatchEnum = typeof VehicleRentalCurrentRateMatchEnum[keyof typeof VehicleRentalCurrentRateMatchEnum];


/**
 * Check if a given object implements the VehicleRental interface.
 */
export function instanceOfVehicleRental(value: object): value is VehicleRental {
    return true;
}

export function VehicleRentalFromJSON(json: any): VehicleRental {
    return VehicleRentalFromJSONTyped(json, false);
}

export function VehicleRentalFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRental {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'providerBookingId': json['provider_booking_id'] == null ? undefined : json['provider_booking_id'],
        'vendorCode': json['vendor_code'] == null ? undefined : json['vendor_code'],
        'vendorName': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'pickupLocationCode': json['pickup_location_code'] == null ? undefined : json['pickup_location_code'],
        'pickupLocationType': json['pickup_location_type'] == null ? undefined : json['pickup_location_type'],
        'pickupDatetime': json['pickup_datetime'] == null ? undefined : (new Date(json['pickup_datetime'])),
        'dropoffLocationCode': json['dropoff_location_code'] == null ? undefined : json['dropoff_location_code'],
        'dropoffLocationType': json['dropoff_location_type'] == null ? undefined : json['dropoff_location_type'],
        'dropoffDatetime': json['dropoff_datetime'] == null ? undefined : (new Date(json['dropoff_datetime'])),
        'acrissCode': json['acriss_code'] == null ? undefined : json['acriss_code'],
        'vehicleClass': json['vehicle_class'] == null ? undefined : json['vehicle_class'],
        'vehicleCategory': json['vehicle_category'] == null ? undefined : json['vehicle_category'],
        'vehicleDescription': json['vehicle_description'] == null ? undefined : json['vehicle_description'],
        'transmissionType': json['transmission_type'] == null ? undefined : json['transmission_type'],
        'airConditioning': json['air_conditioning'] == null ? undefined : json['air_conditioning'],
        'passengerCount': json['passenger_count'] == null ? undefined : json['passenger_count'],
        'bagCount': json['bag_count'] == null ? undefined : json['bag_count'],
        'totalRate': json['total_rate'] == null ? undefined : json['total_rate'],
        'dailyRate': json['daily_rate'] == null ? undefined : json['daily_rate'],
        'billingCurrency': json['billing_currency'] == null ? undefined : json['billing_currency'],
        'cancelled': json['cancelled'] == null ? undefined : json['cancelled'],
        'cancelledAt': json['cancelled_at'] == null ? undefined : (new Date(json['cancelled_at'])),
        'bookingAgent': json['booking_agent'] == null ? undefined : json['booking_agent'],
        'bookingDate': json['booking_date'] == null ? undefined : (new Date(json['booking_date'])),
        'loyaltyProgram': json['loyalty_program'] == null ? undefined : json['loyalty_program'],
        'loyaltyId': json['loyalty_id'] == null ? undefined : json['loyalty_id'],
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'pickupCounterLocation': json['pickup_counter_location'] == null ? undefined : json['pickup_counter_location'],
        'pickupShuttleInfo': json['pickup_shuttle_info'] == null ? undefined : json['pickup_shuttle_info'],
        'pickupAddress': json['pickup_address'] == null ? undefined : json['pickup_address'],
        'pickupPhone': json['pickup_phone'] == null ? undefined : json['pickup_phone'],
        'dropoffCounterLocation': json['dropoff_counter_location'] == null ? undefined : json['dropoff_counter_location'],
        'dropoffShuttleInfo': json['dropoff_shuttle_info'] == null ? undefined : json['dropoff_shuttle_info'],
        'dropoffAddress': json['dropoff_address'] == null ? undefined : json['dropoff_address'],
        'dropoffPhone': json['dropoff_phone'] == null ? undefined : json['dropoff_phone'],
        'cancellationPolicy': json['cancellation_policy'] == null ? undefined : json['cancellation_policy'],
        'autoSave': json['auto_save'] == null ? undefined : json['auto_save'],
        'currentRate': json['current_rate'] == null ? undefined : json['current_rate'],
        'currentRateCurrency': json['current_rate_currency'] == null ? undefined : json['current_rate_currency'],
        'currentRateUpdatedAt': json['current_rate_updated_at'] == null ? undefined : (new Date(json['current_rate_updated_at'])),
        'currentRateMatch': json['current_rate_match'] == null ? undefined : json['current_rate_match'],
        'currentRateVendorCode': json['current_rate_vendor_code'] == null ? undefined : json['current_rate_vendor_code'],
        'currentRateAcrissCode': json['current_rate_acriss_code'] == null ? undefined : json['current_rate_acriss_code'],
        'tripId': json['trip_id'] == null ? undefined : json['trip_id'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
        'monitoringStatus': json['monitoring_status'] == null ? undefined : MonitoringStatusFromJSON(json['monitoring_status']),
        'monitoringReason': json['monitoring_reason'] == null ? undefined : json['monitoring_reason'],
        'missingFields': json['missing_fields'] == null ? undefined : json['missing_fields'],
        'autosaveAvailable': json['autosave_available'] == null ? undefined : json['autosave_available'],
        'monitoringLastCheckedAt': json['monitoring_last_checked_at'] == null ? undefined : (new Date(json['monitoring_last_checked_at'])),
    };
}

export function VehicleRentalToJSON(json: any): VehicleRental {
    return VehicleRentalToJSONTyped(json, false);
}

export function VehicleRentalToJSONTyped(value?: VehicleRental | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'gondola_booking_id': value['gondolaBookingId'],
        'provider_booking_id': value['providerBookingId'],
        'vendor_code': value['vendorCode'],
        'vendor_name': value['vendorName'],
        'pickup_location_code': value['pickupLocationCode'],
        'pickup_location_type': value['pickupLocationType'],
        'pickup_datetime': value['pickupDatetime'] == null ? value['pickupDatetime'] : value['pickupDatetime'].toISOString(),
        'dropoff_location_code': value['dropoffLocationCode'],
        'dropoff_location_type': value['dropoffLocationType'],
        'dropoff_datetime': value['dropoffDatetime'] == null ? value['dropoffDatetime'] : value['dropoffDatetime'].toISOString(),
        'acriss_code': value['acrissCode'],
        'vehicle_class': value['vehicleClass'],
        'vehicle_category': value['vehicleCategory'],
        'vehicle_description': value['vehicleDescription'],
        'transmission_type': value['transmissionType'],
        'air_conditioning': value['airConditioning'],
        'passenger_count': value['passengerCount'],
        'bag_count': value['bagCount'],
        'total_rate': value['totalRate'],
        'daily_rate': value['dailyRate'],
        'billing_currency': value['billingCurrency'],
        'cancelled': value['cancelled'],
        'cancelled_at': value['cancelledAt'] == null ? value['cancelledAt'] : value['cancelledAt'].toISOString(),
        'booking_agent': value['bookingAgent'],
        'booking_date': value['bookingDate'] == null ? value['bookingDate'] : value['bookingDate'].toISOString(),
        'loyalty_program': value['loyaltyProgram'],
        'loyalty_id': value['loyaltyId'],
        'confirmation_number': value['confirmationNumber'],
        'pickup_counter_location': value['pickupCounterLocation'],
        'pickup_shuttle_info': value['pickupShuttleInfo'],
        'pickup_address': value['pickupAddress'],
        'pickup_phone': value['pickupPhone'],
        'dropoff_counter_location': value['dropoffCounterLocation'],
        'dropoff_shuttle_info': value['dropoffShuttleInfo'],
        'dropoff_address': value['dropoffAddress'],
        'dropoff_phone': value['dropoffPhone'],
        'cancellation_policy': value['cancellationPolicy'],
        'auto_save': value['autoSave'],
        'current_rate': value['currentRate'],
        'current_rate_currency': value['currentRateCurrency'],
        'current_rate_updated_at': value['currentRateUpdatedAt'] == null ? value['currentRateUpdatedAt'] : value['currentRateUpdatedAt'].toISOString(),
        'current_rate_match': value['currentRateMatch'],
        'current_rate_vendor_code': value['currentRateVendorCode'],
        'current_rate_acriss_code': value['currentRateAcrissCode'],
        'trip_id': value['tripId'],
        'image_url': value['imageUrl'],
        'monitoring_status': MonitoringStatusToJSON(value['monitoringStatus']),
        'monitoring_reason': value['monitoringReason'],
        'missing_fields': value['missingFields'],
        'autosave_available': value['autosaveAvailable'],
        'monitoring_last_checked_at': value['monitoringLastCheckedAt'] == null ? value['monitoringLastCheckedAt'] : value['monitoringLastCheckedAt'].toISOString(),
    };
}

